import axios from "axios";

export function editTemplate(payload) {
  return new Promise((resolve, reject) => {
    axios.put(`/serialnumber/api/v1/product-ui-template/${payload.id}`, payload)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
